import { Star, BadgeCheck } from "lucide-react";
import { SERVICES } from "@/data/services";

export const SERVICE_OPTIONS = [...SERVICES.map((service) => ({ id: service.id, name: `${service.num} — ${service.name}` })), { id: "autre", name: "Autre" }];
export const SERVICE_LABEL = Object.fromEntries([...SERVICES.map((service) => [service.id, service.name]), ["autre", "Autre"]]);

export const VerifiedBadge = ({ size = 12, testId = "review-verified-badge" }) => (
  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-emerald-400/40 bg-emerald-400/10 text-emerald-300 font-mono-ui text-[9px] uppercase" data-testid={testId} title="Identité confirmée via Google"><BadgeCheck size={size} />Vérifié</span>
);

export const Stars = ({ value, size = 16, interactive = false, onChange, hover, onHover, testId = "review-form-stars" }) => (
  <div className="flex items-center gap-1" data-testid={testId} aria-label={`${value} étoiles sur 5`}>
    {[1, 2, 3, 4, 5].map((n) => {
      const star = <Star size={size} className={n <= (hover || value) ? "text-amber-400 fill-amber-400" : "text-slate-600"} />;
      if (!interactive) return <span key={n}>{star}</span>;
      return <button key={n} type="button" onClick={() => onChange(n)} onMouseEnter={() => onHover(n)} onMouseLeave={() => onHover(0)} data-testid={`star-${n}`} aria-pressed={value === n} aria-label={`${n} étoile${n > 1 ? "s" : ""}`} className="transition-transform hover:scale-125 active:scale-95">{star}</button>;
    })}
  </div>
);

export const GoogleMark = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34.1 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.6-.4-3.9z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3l5.7-5.7C34.1 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C36.9 39.2 44 34 44 24c0-1.3-.1-2.6-.4-3.9z" />
  </svg>
);